import React, { useState } from "react";
import classNames from "classnames";
import MenuItem from "./MenuItem";
import SubMenu from "./SubMenu";
/**
 *
 * A versatile menu for navigation.
 *
 *  ```javascript
 *      import { Menu } from 'miever_components';
 *  ```
 *
 * @param IMenuComponent
 * @returns
 */
var Menu = function (_a) {
    var className = _a.className, _b = _a.mode, mode = _b === void 0 ? 'horizontal' : _b, style = _a.style, items = _a.items, _c = _a.defaultKey, defaultKey = _c === void 0 ? "0" : _c, _d = _a.onSelect, onSelect = _d === void 0 ? function () { } : _d, prefix = _a.prefix, suffix = _a.suffix;
    var _e = useState(defaultKey), currentKey = _e[0], setCurrentKey = _e[1];
    var classes = classNames('menu', className, {
        'menu-vertical': mode === 'vertical',
        'menu-horizontal': mode !== 'vertical'
    });
    var handleClick = function (key) {
        setCurrentKey(key);
        onSelect === null || onSelect === void 0 ? void 0 : onSelect(key);
    };
    var renderChildren = function () {
        return items.map(function (item) {
            var label = item.label, key = item.key, _a = item.children, children = _a === void 0 ? [] : _a, disabled = item.disabled;
            if (children && children.length) {
                return (React.createElement(SubMenu, { key: key, itemKey: key, title: label, items: children, mode: mode, currentKey: currentKey, handleClick: handleClick }));
            }
            return (React.createElement(MenuItem, { key: key, disabled: disabled, currentKey: currentKey, itemKey: key, label: label, handleClick: function () { return handleClick(key); } }));
        });
    };
    return (React.createElement("ul", { style: style, className: classes },
        mode === "horizontal" && prefix,
        renderChildren(),
        mode === "horizontal" && suffix && React.createElement("div", { style: { position: "absolute", right: 0 } }, suffix)));
};
export default Menu;
